// QuickShop Module - Debugging enabled
class QuickShop {
  constructor() {
    this.modal = document.getElementById('quick-shop-modal');
    if (!this.modal) return;
    
    this.container = this.modal.querySelector('.quick-shop-modal__container');
    this.content = document.getElementById('quick-shop-modal-content');
    this.closeBtn = this.modal.querySelector('.quick-shop-modal__close');
    this.backdrop = this.modal.querySelector('.quick-shop-modal__backdrop');
    
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-quick-shop-trigger]');
      if (target) {
        e.preventDefault();
        const handle = target.getAttribute('data-product-handle');
        this.open(handle);
      }
    });

    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  async open(handle) {
    if (!handle) return;
    this.modal.classList.add('active');
    this.content.classList.add('is-loading');
    document.body.style.overflow = 'hidden';
    
    this.content.innerHTML = '<div class="quick-shop-modal__loading"><div class="spinner"></div></div>';
    
    try {
      const response = await fetch(`/products/${handle}?section_id=quick-shop-content`);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionContent = doc.querySelector('.quick-shop-content');
      
      if (sectionContent) {
        // Delay to ensure styles are ready and content is processed
        setTimeout(() => {
          this.content.innerHTML = sectionContent.outerHTML;
          this.initContentEvents();
          
          // Extra frame to allow DOM rendering before showing
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.content.classList.remove('is-loading');
            }, 50);
          });
        }, 300);
      } else {
        this.content.innerHTML = '<p style="padding: 2rem; text-align: center;">Erro ao carregar produto.</p>';
        this.content.classList.remove('is-loading');
      }
    } catch (error) {
      console.error('Quick Shop Error:', error);
      this.content.innerHTML = '<p style="padding: 2rem; text-align: center;">Erro de conexão.</p>';
      this.content.classList.remove('is-loading');
    }
  }

  close() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  initContentEvents() {
    const content = this.content.querySelector('.quick-shop-content');
    if (!content) return;
    
    const conjuntoContainer = content.querySelector('[data-product-conjunto]');
    const addToCartBtn = content.querySelector('.quick-shop-content__add-to-cart');
    const productId = content.getAttribute('data-product-id');
    const variantsDataEl = document.getElementById(`QuickShopVariants-${productId}`);
    const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

    if (conjuntoContainer) {
      this.initConjuntoEvents(conjuntoContainer, addToCartBtn);
    } else {
      const optionGroups = content.querySelectorAll('.quick-shop-option');
      if (optionGroups.length > 0) {
        this.initStandardEvents(content, variantsData, addToCartBtn);
      } else if (addToCartBtn && addToCartBtn.hasAttribute('data-variant-id')) {
        // Simple product already has its variant ID set in Liquid
        if (addToCartBtn.querySelector('.button-text').textContent !== 'Indisponível') {
          addToCartBtn.disabled = false;
        }
      }
    }

    // Dynamic Color Switching from swatches
    content.querySelectorAll('.color-item[data-product-handle]').forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = item.getAttribute('data-product-handle');
        this.open(handle);
      });
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async () => {
        let items = [];
        
        if (conjuntoContainer) {
          const checkedBoxes = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input:checked');
          checkedBoxes.forEach(checkbox => {
            if (checkbox.dataset.variantId) {
              items.push({ id: checkbox.dataset.variantId, quantity: 1 });
            }
          });
        } else {
          const variantId = addToCartBtn.getAttribute('data-variant-id');
          if (variantId) {
            items.push({ id: variantId, quantity: 1 });
          }
        }

        if (items.length === 0) return;
        
        addToCartBtn.classList.add('loading');
        addToCartBtn.disabled = true;
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          
          if (response.ok) {
            const data = await response.json();
            this.close();
            
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              detail: { items: data.items ? data.items : [data] }
            }));
            
            document.dispatchEvent(new CustomEvent('updateCartDrawer'));
          } else {
            const err = await response.json();
            alert('Erro: ' + (err.description || err.message));
          }
        } catch (error) {
          console.error('Add to cart error:', error);
        } finally {
          addToCartBtn.classList.remove('loading');
          addToCartBtn.disabled = false;
        }
      });
    }
  }

  initStandardEvents(content, variantsData, addToCartBtn) {
    const optionContainers = content.querySelectorAll('.quick-shop-option');
    let selectedOptions = {};

    optionContainers.forEach(container => {
      const optionIndex = parseInt(container.getAttribute('data-option-index'));
      const buttons = container.querySelectorAll('.quick-shop-option__value');
      
      // DEBUG FIX: Pre-select hidden options (like "Cor" when only 1 exists)
      if (container.style.display === 'none' && buttons.length > 0) {
        selectedOptions[optionIndex] = buttons[0].getAttribute('data-option-value');
      }

      // Check for pre-selected option (e.g. hidden Color or pre-selected Size)
      const selectedBtn = container.querySelector('.quick-shop-option__value.selected');
      if (selectedBtn) {
        selectedOptions[optionIndex] = selectedBtn.getAttribute('data-option-value');
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.classList.contains('disabled')) return;
          const value = btn.getAttribute('data-option-value');
          buttons.forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedOptions[optionIndex] = value;
          
          this.updateVariantSelection(variantsData, selectedOptions, addToCartBtn, optionContainers.length);
          this.updateOptionsAvailability(variantsData, selectedOptions, optionContainers);
        });
      });
    });

    // Initial check
    this.updateVariantSelection(variantsData, selectedOptions, addToCartBtn, optionContainers.length);
    this.updateOptionsAvailability(variantsData, selectedOptions, optionContainers);
  }

  updateOptionsAvailability(variants, selectedOptions, optionContainers) {
    optionContainers.forEach(container => {
      const optionIndex = parseInt(container.getAttribute('data-option-index'));
      const buttons = container.querySelectorAll('.quick-shop-option__value');

      buttons.forEach(btn => {
        const value = btn.getAttribute('data-option-value');
        
        // Check if this value is available given current selections for OTHER options
        const isAvailable = variants.some(variant => {
          // Must match current candidate value
          if (variant.options[optionIndex] !== value) return false;
          
          // Must match ALL other *selected* options
          const matchesOtherSelections = Object.keys(selectedOptions).every(key => {
            const idx = parseInt(key);
            if (idx === optionIndex) return true;
            return selectedOptions[idx] === variant.options[idx];
          });

          return matchesOtherSelections && variant.available;
        });

        const label = btn.querySelector('.size-label');
        if (isAvailable) {
          btn.classList.remove('disabled');
          btn.disabled = false;
          if (label) label.classList.remove('unavailable');
        } else {
          btn.classList.add('disabled');
          // We don't necessarily want to disable clicking if we want them to see "Sold Out"
          // but for Quick Shop circles, it's better to disable to avoid confusion.
          btn.disabled = false; // Keep clickable to allow changing color first? 
          // Actually, if it's disabled, they can't select it.
          // Let's make it disabled but still allow selection if we want "Sold Out" button state.
          // The request was "show availability", so marking it unavailable is enough.
          if (label) label.classList.add('unavailable');
        }
      });
    });
  }

  initConjuntoEvents(container, addToCartBtn) {
    // Initial state
    this.updateConjuntoBtnState(container, addToCartBtn);

    container.addEventListener('click', (e) => {
      const optionButton = e.target.closest('.conjunto-option-value');
      if (optionButton && !optionButton.disabled) {
        const productItem = optionButton.closest('.conjunto-product-item');
        const variantId = optionButton.dataset.variantId;
        const variantImage = optionButton.dataset.variantImage;

        // Update selected state
        const optionGroup = optionButton.closest('.conjunto-option-values');
        optionGroup.querySelectorAll('.conjunto-option-value').forEach(btn => btn.classList.remove('selected'));
        optionButton.classList.add('selected');

        // Update checkbox/item variant ID
        const checkbox = productItem.querySelector('.conjunto-product-checkbox-input');
        if (checkbox) checkbox.dataset.variantId = variantId;

        // Update image if exists
        const imageElement = productItem.querySelector('[data-conjunto-image]');
        if (imageElement && variantImage) {
          // Adjust URL to match 400x600 crop
          const imgUrl = variantImage.replace(/(_\d+x\d+)?(\.[a-z]+(\?.*)?)$/, '_400x600_crop_center$2');
          imageElement.src = imgUrl;
        }

        this.updateConjuntoBtnState(container, addToCartBtn);
      }

      if (e.target.classList.contains('conjunto-product-checkbox-input')) {
        this.updateConjuntoBtnState(container, addToCartBtn);
      }
    });
  }

  updateConjuntoBtnState(container, addToCartBtn) {
    const allBoxes = container.querySelectorAll('.conjunto-product-checkbox-input');
    const disabledBoxes = container.querySelectorAll('.conjunto-product-checkbox-input:disabled');
    
    // If every item is completely out of stock, force Indisponível
    if (allBoxes.length > 0 && disabledBoxes.length === allBoxes.length) {
      addToCartBtn.disabled = true;
      const textSpan = addToCartBtn.querySelector('.button-text');
      if (textSpan) textSpan.textContent = 'Indisponível';
      return;
    }

    const checkedBoxes = container.querySelectorAll('.conjunto-product-checkbox-input:checked');
    let validConjunto = checkedBoxes.length > 0;

    checkedBoxes.forEach(checkbox => {
      const item = checkbox.closest('.conjunto-product-item');
      if (item) {
        const hasOptions = item.querySelector('.conjunto-product-options');
        if (hasOptions) {
          const hasSelected = item.querySelector('.conjunto-option-value.selected');
          if (!hasSelected) {
            validConjunto = false;
          }
        }
      }
    });

    if (validConjunto) {
      addToCartBtn.disabled = false;
      const textSpan = addToCartBtn.querySelector('.button-text');
      if (textSpan) textSpan.textContent = 'Adicionar ao carrinho';
    } else {
      addToCartBtn.disabled = true;
      const textSpan = addToCartBtn.querySelector('.button-text');
      if (textSpan) textSpan.textContent = 'Selecione as opções';
    }
  }

  updateVariantSelection(variants, selectedOptions, submitBtn, totalOptions) {
    const selectedCount = Object.keys(selectedOptions).length;

    // Check if there are ANY available matching variants for the current partial selection
    const hasAnyAvailableVariant = variants.some(variant => {
      return Object.keys(selectedOptions).every(key => {
        const optIndex = parseInt(key);
        return selectedOptions[optIndex] === variant.options[optIndex];
      }) && variant.available;
    });

    if (selectedCount < totalOptions) {
      submitBtn.disabled = true;
      if (!hasAnyAvailableVariant) {
        submitBtn.querySelector('.button-text').textContent = 'Indisponível';
      } else {
        submitBtn.querySelector('.button-text').textContent = 'Selecione o tamanho';
      }
      return;
    }
    
    // DEBUG FIX: Robust matching using keys directly
    let matchedVariant = variants.find(variant => {
      const matchesSelection = Object.keys(selectedOptions).every(key => {
        const optIndex = parseInt(key);
        return selectedOptions[optIndex] === variant.options[optIndex];
      });
      return matchesSelection && variant.available;
    });

    if (!matchedVariant) {
      matchedVariant = variants.find(variant => {
        return Object.keys(selectedOptions).every(key => {
          const optIndex = parseInt(key);
          return selectedOptions[optIndex] === variant.options[optIndex];
        });
      });
    }
    
    if (matchedVariant) {
      // Update Price
      const priceContainer = this.modal.querySelector('.card-product-prices');
      if (priceContainer) {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });

        const formattedPrice = formatter.format(matchedVariant.price / 100);
        const priceElement = priceContainer.querySelector('[data-total-price]');
        if (priceElement) priceElement.textContent = formattedPrice;

        const comparePriceElement = priceContainer.querySelector('[data-total-compare-price]');
        if (comparePriceElement) {
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceElement.textContent = formatter.format(matchedVariant.compare_at_price / 100);
            comparePriceElement.style.display = 'inline-block';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }

        // Update Installments
        const installmentsContainer = priceContainer.querySelector('[data-installments]');
        if (installmentsContainer) {
          const installmentsDefault = parseInt(priceContainer.dataset.installmentsDefault || 5);
          const installmentsMinimum = parseInt(priceContainer.dataset.installmentsMinimum || 30);
          const priceInReais = matchedVariant.price / 100;

          if (priceInReais >= installmentsMinimum) {
            const installmentAmount = formatter.format(matchedVariant.price / 100 / installmentsDefault);
            const amountElement = installmentsContainer.querySelector('[data-installment-amount]');
            if (amountElement) amountElement.textContent = installmentAmount;
            installmentsContainer.style.display = 'block';
          } else {
            installmentsContainer.style.display = 'none';
          }
        }

        // Update PIX
        const pixContainer = priceContainer.querySelector('[data-pix-price]');
        if (pixContainer) {
          const pixPercentage = parseFloat(priceContainer.dataset.pixPercentage || 5);
          const pixDiscountAmount = matchedVariant.price * (pixPercentage / 100);
          const pixFinalPrice = formatter.format((matchedVariant.price - pixDiscountAmount) / 100);
          const pixAmountElement = pixContainer.querySelector('[data-pix-amount]');
          if (pixAmountElement) pixAmountElement.textContent = pixFinalPrice;
        }
      }

      if (matchedVariant.available) {
        submitBtn.disabled = false;
        submitBtn.setAttribute('data-variant-id', matchedVariant.id);
        submitBtn.querySelector('.button-text').textContent = 'Adicionar ao carrinho';
      } else {
        submitBtn.disabled = true;
        submitBtn.querySelector('.button-text').textContent = 'Indisponível';
      }
    } else {
      submitBtn.disabled = true;
      submitBtn.querySelector('.button-text').textContent = 'Indisponível';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.QuickShopInstance = new QuickShop();
});
